import { render, staticRenderFns } from "./CreateNewPrintItemButton.vue?vue&type=template&id=5a44be1e&scoped=true"
import script from "./CreateNewPrintItemButton.vue?vue&type=script&lang=js"
export * from "./CreateNewPrintItemButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44be1e",
  null
  
)

export default component.exports